'use strict';

const $ = require('jquery');
const errorClassName = 'c-input-container--error';

module.exports = class FormValidation {

  constructor() {

    this.init();
  }

  init() {

    $('input[data-validate="email"]').on('keyup change', (e) => {
      const value = e.target.value;
      const $input = $(e.currentTarget);
      const valid = isNotEmpty(value) && hasAmpersat(value);

      if (valid)
        this.showValid($input);
      else
        this.showError($input);
    });

    $('input[data-validate="password"]').on('keyup change', (e) => {
      const value = e.target.value;
      const $input = $(e.currentTarget);
      const valid = value.trim().length >= 8;

      if (valid)
        this.showValid($input);
      else
        this.showError($input);
    });
  }

  showValid($input) {
    $input.closest('label').addClass('c-input-container--success').removeClass('c-input-container--error');
  }

  showError($input) {
    $input.closest('label').addClass('c-input-container--error').removeClass('c-input-container--success');
  }
};

const isNotEmpty = a => a !== null && a.trim().length > 0;
const hasAmpersat = a => /\S+@\S+\.\S+/.test(a);
